<template lang="pug">
.bg-page
  .container
    section.notfound
      img(src="~assets/404.png")
      .title NOT FOUND
      .content
        h1 頁面錯誤 你迷路了嗎
        .description
          | 您可以至
          router-link(:to="{name: 'activity'}") 活動資訊
          | 了解活動
      .btn-row
        router-link(:to="{name: 'ticketType'}").btn.ghost-btn 購買票卷
        router-link(:to="{name: 'selectArea'}").btn.ghost-btn 察看座位圖
</template>

<script>
import { mapGetters } from 'vuex'
// import _ from 'lodash'

export default {
  name: 'notfound',
  beforeRouteEnter (to, from, next) {
    next(vm => {
    })
  },
  beforeRouteLeave (to, from, next) {
    next(vm => {
    })
  },
  props: {
    fullScreenCount: {
      type: Object
    },
    isMobile: {
      type: Boolean
    },
    mobileMenuSwitch: {
      type: [Boolean, Function]
    },
    isPortrait: {
      type: Boolean
    }
  },
  data () {
    return {
    }
  },
  computed: {
    ...mapGetters([
    ])
  },
  methods: {
  },
  mounted () {
    // Place images after loaded
    this.$Lazyload.$on('loaded', () => {
      console.log('Loaded')
    })
  },
  watch: {
  },
  beforeDestroy () {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="sass" scoped>
@import '~stylesheets/variables'
@import '~stylesheets/components'
@import '~stylesheets/mixin'
.notfound
  margin: 120px auto
  @media screen and (max-width: 640px)
    margin: 40px auto
  img
    display: block
    margin: 0 auto
  .title
    color: $red
    font-size: 30px
    font-weight: bold
    text-align: center
    margin-bottom: 30px
  .content
    h1
      margin-bottom: 16px
    .description
      font-size: 16px
      text-align: center
      a
        color: $red
        margin: 0 12px
  .btn-row
    margin-top: 30px
    text-align: center
    a
      margin: 20px 8px
</style>



// WEBPACK FOOTER //
// notFound.vue?b894afce